import ActivitiesConfigure from '@/views/activities/ActivitiesConfigure';

export default [
   {
      name: 'activities-configure',
      path: '/company/:id/activities',
      component: ActivitiesConfigure,
      meta: {
         breadCrumb: [
            {text: 'Dashboard', to: {name: 'Home'}},
            {
               text: '__COMPANYNAME__',
               // BreadCrumbs component fills id with current route param
               to: {name: 'company-detail', params: {id: 'FILL'}},
            },
            {text: 'Configure Activities'},
         ],
         authGroup: 'rndig',
      },
   },
];
